const amazonOAuth = {
	redirect_uri: `https://scanshipco.com/api/fulfillment/oauth/amazon`,
	applicationId: 'amzn1.sp.solution.9e4681bb-995a-4aa1-8b41-7ba630be1d3f',
};

const shopifyOAuth = {
	redirect_uri: `https://staging.scanshipco.com/api/fulfillment/oauth/shopify`,
};

const shopifyScopes = 'read_all_orders,write_inventory,read_products,write_assigned_fulfillment_orders,write_merchant_managed_fulfillment_orders';

const stampsOAuth = {
	redirect_uri: `https://scanshipco.com/api/fulfillment/oauth/stamps`,
	response_type: `code`,
	clientIdStaging: `rrhh8TVI5QllLlcRsTXEMKpuugVZUqTD`,
	clientIdProduction: `4fjq3Z1Cynn9ZwNINaQ3i8ocovgVizmT`,
	baseUrlProduction: `https://signin.stampsendicia.com/authorize`,
	baseUrlStaging: `https://signin.testing.stampsendicia.com/authorize`,
};

function getAmazonOAuthUrl(isVendor = false, amazonOAuthStateHash) {
	return `https://${isVendor ? 'vendor' : 'seller'}central.amazon.com/apps/authorize/consent?application_id=${
		amazonOAuth.applicationId
	}&state=${amazonOAuthStateHash}&redirect_uri=${amazonOAuth.redirect_uri}`;
}

function getShopifyOAuthUrl(shop) {
	return `https://${shop}/admin/oauth/authorize?client_id=4f3c4c34ee2316c003f44b4a242b02f9&scope=${shopifyScopes}&redirect_uri=${shopifyOAuth.redirect_uri}`;
}

function getStampsOAuthUrl() {
	return process.env.NODE_ENV == 'production'
		? `${stampsOAuth.baseUrlProduction}?client_id=${stampsOAuth.clientIdProduction}&response_type=${stampsOAuth.response_type}&redirect_uri=${stampsOAuth.redirect_uri}&scope=offline_access`
		: `${stampsOAuth.baseUrlStaging}?client_id=${stampsOAuth.clientIdStaging}&response_type=${stampsOAuth.response_type}&redirect_uri=${stampsOAuth.redirect_uri}&scope=offline_access`;
}

const upsOAuth = {
	redirectUri: `https://scanshipco.com/api/fulfillment/oauth/ups`,
	response_type: `code`,
	scope: 'read',
	type: 'ups_com_api',
	clientId: `Qggpr0D1GLlNz25ehq4ApgdKH9S6zHGzmYbx7YSttZz5J8Az`,
	baseUrl: `https://www.ups.com/lasso/signin`,
};

function getUpsOAuthUrl() {
	return `${upsOAuth.baseUrl}?client_id=${upsOAuth.clientId}&redirect_uri=${upsOAuth.redirectUri}&response_type=${upsOAuth.response_type}&scope=${upsOAuth.read}&type=${upsOAuth.type}`;
}

export { amazonOAuth, getAmazonOAuthUrl, getStampsOAuthUrl, getUpsOAuthUrl, getShopifyOAuthUrl };
